/** Calendar row is a makeup slot for a prior cancellation (not a regular recurring session). */
export function isSupposedMakeupSession(session) {
  if (!session) {
    return false;
  }

  if (session.is_makeup || session.isMakeupSession) {
    return true;
  }

  return Boolean(session.makeup_for && session.session_attendance_id);
}

/**
 * Attendance fields when a supposed makeup day is cancelled or late-cancelled.
 */
export function getSupposedMakeupCancellationAttendance({
  status,
  cancelledByTherapist,
  paidNoShowFee,
  rescheduleMakeup = false,
}) {
  const isCancelledOrAbsent = status === 'cancelled' || status === 'absent';
  const waiveByTherapist = Boolean(cancelledByTherapist);
  const feePaid = Boolean(paidNoShowFee);
  const rescheduling = Boolean(rescheduleMakeup);

  let madeupForValue = null;
  let makeupScheduledValue = null;

  if (isCancelledOrAbsent) {
    if (waiveByTherapist || feePaid || rescheduling) {
      madeupForValue = null;
      makeupScheduledValue = null;
    } else {
      madeupForValue = null;
      makeupScheduledValue = null;
    }
  }

  let finalAmount = 0;
  let isPaidValue = false;
  let amountPaidValue = null;
  let paidNoshow = null;
  let makeupFeeVoidedByTherapist = null;

  if (status === 'absent') {
    if (waiveByTherapist || rescheduling) {
      finalAmount = 0;
    } else if (feePaid) {
      finalAmount = 0;
      isPaidValue = true;
      amountPaidValue = 950;
    } else {
      finalAmount = 950;
    }
  } else if (status === 'cancelled') {
    if (feePaid) {
      isPaidValue = true;
      amountPaidValue = 950;
    }
  }

  if (isCancelledOrAbsent) {
    paidNoshow = feePaid ? true : waiveByTherapist || rescheduling ? null : false;
    makeupFeeVoidedByTherapist = waiveByTherapist;
  }

  return {
    madeupForValue,
    makeupScheduledValue,
    finalAmount,
    isPaidValue,
    amountPaidValue,
    paidNoshow,
    makeupFeeVoidedByTherapist,
  };
}
